// extracted by mini-css-extract-plugin
export var cardTitle = "_in-1";
export var commentBubble = "_in-e";
export var commentForm = "_in-a";
export var commentInput = "_in-b";
export var commentLabel = "_in-d";
export var commentPrompt = "_in-9";
export var csatCard = "_in-0";
export var feedbackSection = "_in-7";
export var starDisabled = "_in-6";
export var starEmpty = "_in-5";
export var starFilled = "_in-4";
export var starWrapper = "_in-3";
export var starsContainer = "_in-2";
export var submittedComment = "_in-c";
export var thankYouText = "_in-8";